/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsMarketingPreferences204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsMarketingPreferences505Schema = z.any();

export const optionsMarketingPreferencesMutationResponseSchema = z.lazy(() => optionsMarketingPreferences204Schema);
